import { useEffect, useState } from "react";
import NavPages from "../../../components/NavPages/navPages";
import Steps from "../../../components/steps";

import styles from "./checklistAnswers.module.css"

import { useLocation } from "react-router-dom";
import MocSteps from "../../../components/search-moc/MocSteps";
import MocStepActions from "../../../components/search-moc/MocSteps";
import { api } from "../../../services/api";
import BasicInfo from "../../../components/search-moc/basicInfo";
import ChecklistSupport from "../../../components/search-moc/checklistSupport";
import HseApproval from "../../../components/search-moc/hseApproval";
import Button from "../../../components/Button";
import Swal from "sweetalert2";
import exportToPDF from "../../../utils/exportToPdf";
import LoadingContent from "../../../components/loadingContent/loadingContent";
import { printPage } from "../../../utils/pdfExport";

export default function ChecklistAnswers() {
    const location = useLocation()
    const id = location.state.state
    const title = location.state.title
    const subTitle = location.state.subTitle
    const mocTitle = location.state.mocTitle

    // Estado que determina se o moc é completo ou simplificado
    const [isComplete, setIsComplete] = useState(true)

    const [stages, setStages] = useState([])

    const [activeDiv, setActiveDiv] = useState(false)

    const [isLoading, setIsLoading] = useState(false)

    const [disableDivsOpacity, setDisableDivsOpacity] = useState(false)

    const [evidenceObservation, setEvidenceObservation] = useState('')

    useEffect(async () => {
        await getMocStageData()
    }, [])

    async function getMocStageData() {
        try {
            setIsLoading(true)

            let response = await api.get(`/stages/moc/${id}`)

            if (response.data[0].Stages.id == 4) {
                setIsComplete(false)
            }

            setStages(response.data)
        }
        catch (error) {
            console.error(error)
        } finally {
            setIsLoading(false)
        }
    }

    async function startExporting() {
        setActiveDiv(true)
        setDisableDivsOpacity(true)
        setEvidenceObservation(true)
        await Swal.fire({
            text: 'O carregamento do arquivo pode demorar alguns minutos.',
            icon: 'info',
            confirmButtonColor: "#009EBE",
            confirmButtonText: 'Gerar PDF',
            allowOutsideClick: false,
            didClose: () => {window.print()}
        });
        await new Promise(resolve => setTimeout(resolve, 1000));
        setDisableDivsOpacity(false)
        setEvidenceObservation(false)
    }

    return (
        <>
            <Steps
                id={id}
            />

            <NavPages title={title} secondTitle={subTitle} />

            <LoadingContent isLoading={isLoading}>

                <div className="exportPdfDiv">
                    <Button onClick={startExporting}>
                        Exportar para PDF</Button>
                </div>

                <div className="mainDiv PDFExport" >
                    <div className={styles.stepGroup} id="PDFExport">
                        <BasicInfo
                            id={id}
                            activeToggle={activeDiv}
                            disableOpacity={disableDivsOpacity}
                            isEdit={true}
                        />

                        <ChecklistSupport
                            id={id}
                            activeToggle={activeDiv}
                            disableOpacity={disableDivsOpacity}
                        />

                        <HseApproval
                            id={id}
                            activeToggle={activeDiv}
                            disableOpacity={disableDivsOpacity}
                        />
                    </div>


                    {!stages.length > 0 ? <div></div> :
                        isComplete ?
                            <div>
                                < div className={styles.stepGroup}>
                                    <MocSteps
                                        id={id}
                                        stageId={1}
                                        readOnly={stages[0].isCompleted}
                                        activeToggle={activeDiv}
                                        openChecklist={true}
                                        disableOpacity={disableDivsOpacity}
                                        evidenceObservation={evidenceObservation}
                                    />
                                </div>

                                {stages[0].isCompleted ?

                                    <div className={styles.stepGroup}>
                                        <MocSteps
                                            id={id}
                                            stageId={2}
                                            readOnly={stages[1].isCompleted}
                                            activeToggle={activeDiv}
                                            openChecklist={true}
                                            disableOpacity={disableDivsOpacity}
                                            evidenceObservation={evidenceObservation}
                                        />
                                    </div>

                                    : null}

                                {stages[1].isCompleted ?
                                    <div className={styles.stepGroup}>
                                        <MocSteps
                                            id={id}
                                            stageId={3}
                                            readOnly={stages[2].isCompleted}
                                            activeToggle={activeDiv}
                                            openChecklist={true}
                                            disableOpacity={disableDivsOpacity}
                                            evidenceObservation={evidenceObservation}
                                        />
                                    </div>
                                    : null}
                            </div>

                            :

                            < div className={styles.stepGroup}>
                                <MocSteps
                                    id={id}
                                    stageId={4}
                                    readOnly={stages[0].isCompleted}
                                    activeToggle={activeDiv}
                                    openChecklist={true}
                                    disableOpacity={disableDivsOpacity}
                                    evidenceObservation={evidenceObservation}
                                />
                            </div>

                    }
                </div>
            </LoadingContent>

        </>
    )
}